import { RootState } from '../root.reducers';
import { AfFilter, AfFilterGridData } from './afFilter.types';

export const getAfFilterList = (state: RootState): AfFilter[] =>
  state.afFilter.entities;

export const getAfFilter = (state: RootState): AfFilter | null =>
  state.afFilter.single;

export const getSelectedAfFilter = (state: RootState): AfFilterGridData[] =>
  state.afFilter.selected;

export const getAfFilterCreatedId = (state: RootState): string | null =>
  state.afFilter.createdId;

export const isAfFilterCreatePopupOpen = (state: RootState): boolean =>
  state.afFilter.ui.isCreatePopupOpen;

export const isAfFilterLoading = (state: RootState): boolean =>
  state.afFilter.ui.isLoading;
